import * as localForage from 'localforage';

import type { StorageManagerResParams } from './types';

class StorageManager<TData> {
  public instance: StorageManagerResParams<TData>;

  constructor(option?: LocalForageOptions) {
    let targetInstance = localForage;

    if (option) {
      targetInstance = localForage.createInstance(option);
    }

    this.instance = targetInstance as unknown as StorageManagerResParams<TData>;
  }
}

export default StorageManager;
